import {
  createBookingDraft,
  type HaNBookingDraft,
  HaNViewStoreContext,
  selectBookingDraft,
  useHaNView,
} from "@lib/logic";
import { getIsOnlineMeetingLinkSupported, type MeetingRoom, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

/**
 * The room's booking as filled in so far, or a new one. It lives in the view store, so it survives moving between
 * the booking pages, and is only kept once something is edited.
 */
export const useRoomBookingDraft = (room: MeetingRoom) => {
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const isOnlineMeetingSupported = useAppSelector(getIsOnlineMeetingLinkSupported);
  const storedDraft = useHaNView(selectBookingDraft(room.id));

  const draft =
    storedDraft ?? createBookingDraft(room.id, { title: room.displayName, isOnlineMeeting: isOnlineMeetingSupported });

  const edit = (changes: Partial<Omit<HaNBookingDraft, "roomId" | "defaults">>) => {
    viewStore.editBookingDraft({ ...draft, ...changes });
  };

  return { draft, edit };
};
